export default "__VITE_ASSET__22Jbs0me__"